/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_7_ProblemInputs */

const et_portfolio_project_7_problem = /** @type {(inputs: Portfolio_Project_7_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aegunud disain, kehv navigatsioon ja madalad konversioonimäärad.`)
};

const en_portfolio_project_7_problem = /** @type {(inputs: Portfolio_Project_7_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outdated design, poor navigation, and low conversion rates.`)
};

/**
* | output |
* | --- |
* | "Outdated design, poor navigation, and low conversion rates." |
*
* @param {Portfolio_Project_7_ProblemInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_7_problem = /** @type {((inputs?: Portfolio_Project_7_ProblemInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_7_ProblemInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_7_problem(inputs)
	return en_portfolio_project_7_problem(inputs)
});